function parseColorHex(value) {
  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) return numericValue;
  const normalized = String(value || '').trim();
  if (/^#[0-9a-f]{6}$/i.test(normalized)) return Number.parseInt(normalized.slice(1), 16);
  if (/^#[0-9a-f]{3}$/i.test(normalized)) {
    return Number.parseInt(normalized.slice(1).split('').map(char => char + char).join(''), 16);
  }
  return 0xd1d5db;
}

export { parseColorHex };
